import { createFileRoute } from '@tanstack/react-router';
import { FloorEditorPage } from '@/features/office/editor/editor-page';

export const Route = createFileRoute('/w/$workspaceId/office/$floorId_/edit')({ component: EditRoute });

function EditRoute() {
  const { floorId } = Route.useParams();
  return <FloorEditorPage key={floorId} floorId={floorId} />;
}
